export default {
  textMap: {
    "边缘计算特征值": "边缘计算特征值",
    "分段柱状图": "分段柱状图",
    "叶片频率": "叶片频率",
    "趋势图": "趋势图",
    "轨迹图": "轨迹图",
    "瀑布图": "瀑布图",
    "全频谱瀑布图": "全频谱瀑布图",
    "倒谱图": "倒谱图",
    "包络": "包络",
    "使用当前时间": "使用当前时间",
    "放大": "放大",
    "放大还原": "放大还原",
    "还原到上一级": "还原到上一级",
    "导出": "导出",
    "全屏": "全屏",
    "退出全屏": "退出全屏",
    "主游标": "主游标",
    "辅游标": "辅游标",
    "标点": "标点",
    "取消标点": "取消标点",
    "自动寻峰": "自动寻峰",
    "谐频": "谐频",
    "边频": "边频",
    "更多": "更多",
    "阶次": "Order",
    "赫兹": "Hz",
    "标注": "标注",
    "取消标注": "取消标注",
    "清除": "清除",
    "删除图谱": "删除图谱",
    "历史概貌图": "历史概貌图",
    "显示报警线": "显示报警线",
    "隐藏报警线": "隐藏报警线",
    "多参数分析波形图": "多参数分析波形图",
    "波形图": "波形图",
    "频谱图": "频谱图",
    "全频谱图": "全频谱图",
    "单值棒图": "单值棒图",
    "多值棒图": "多值棒图",
    "图": "图",
    "进动方向": "进动方向",
    "正向": "正向",
    "反向": "反向",
    "差量": "差量",
    "天": "天",
    "时": "时",
    "秒": "秒",
    "分": "分",
    "多特征值": "多特征值",
    "气体载荷": "气体载荷",
    "惯性载荷": "惯性载荷",
    "活塞杆载荷": "活塞杆载荷",
    "振动波形": "振动波形",
    "活塞杆载荷监测": "活塞杆载荷监测",
    "幅值转速": "幅值转速",
    "相位转速": "相位转速",
    "缸号": "缸号",
    'p-v图': 'P-V图',
    'p-a图': 'P-A图',
    'p-t图': 'P-T图',
    'logP-logV图': 'logP-logV图',
    "Y轴最小值输入": "Y轴最小值输入",
    "X轴最大值输入": "X轴最大值输入",
    "Y轴最大值输入": "Y轴最大值输入",
    "显示转速": "显示转速",
    "隐藏转速": "隐藏转速",
    "趋势图时间单位": '[时间]',
    "波形图时间单位": '[秒]',
    "暂无报警线信息": "暂无报警线信息",
    "高高报": "高高报",
    "高报": "高报",
    "低低报": "低低报",
    "低报": "低报",
    "输入字符非法，请重新输入": "输入字符非法，请重新输入",
    "已达到图谱数量显示上限": "已达到图谱数量显示上限",
    "时间戳:": "时间戳:",
    "查询时间": "查询时间",
    "切换": "切换",
    "转速": "转速",
    "传统概貌图":"传统概貌图",
    "设备概貌图": "设备概貌图",
    "工艺流程图": "工艺流程图",
    "柱状图": "柱状图",
    "全级联图": "全级联图",
    "级联图": "级联图",
    "轴心位置": "轴心位置",
    "轴心轨迹": "轴心轨迹",
    "操作页": "操作页",
    "开车": "开车",
    "停车": "停车",
    "未知": "未知",
    "总值": "总值",
    "平均值": "平均值",
    "整流平均值": "整流平均值",
    "峰峰值": "峰峰值",
    "波形标准差": "波形标准差",
    "峭度因子": "峭度因子",
    "脉冲因子": "脉冲因子",
    "波形因子": "波形因子",
    "裕度因子": "裕度因子",
    "歪度因子": "歪度因子",
    "峰值因子": "峰值因子",
    "高频总量": "高频总量",
    "中频总量": "中频总量",
    "低频总量": "低频总量",
    "高频能量": "高频能量",
    "中频能量": "中频能量",
    "低频能量": "低频能量",
    "频谱有效值": "频谱有效值",
    "频谱均值": "频谱均值",
    "频率重心": "频率重心",
    "频谱峰值": "频谱峰值",
    "内圈幅值": "内圈幅值",
    "外圈幅值": "外圈幅值",
    "滚动体幅值": "滚动体幅值",
    "保持架幅值": "保持架幅值",
    "特征选择": "特征选择",
    "全选": "全选",
    "内圈特征频率": "内圈特征频率",
    "外圈特征频率": "外圈特征频率",
    "滚动体特征频率": "滚动体特征频率",
    "保持架特征频率": "保持架特征频率",
    "内圈": "内圈",
    "外圈": "外圈",
    "滚动体": "滚动体",
    "保持架": "保持架",
    "转子条频率": "转子条频率",
    "定子槽频率": "定子槽频率",
    "时域特征（幅值）": "时域特征（幅值）",
    "时域特征（指标）": "时域特征（指标）",
    "频域特征（通频）": "频域特征（通频）",
    "频域特征（选频）": "频域特征（选频）",
    "故障特征频率": "故障特征频率",
    "计算轴承": "计算轴承",
    "轴承型号": "轴承型号",
    "请输入正确的转速!": "请输入正确的转速!",
    "滚动体直径或滚动轴承的节圆直径不能为0!": "滚动体直径或滚动轴承的节圆直径不能为0!",
    "通频": "通频",
    "1倍频幅值": "1倍频幅值",
    "2倍频幅值": "2倍频幅值",
    "3倍频幅值": "3倍频幅值",
    "1/2倍频幅值": "1/2倍频幅值",
    "自定义": "自定义",
    "过滤类型": "过滤类型",
    "倍频幅值": "倍频幅值",
    "残振": "残振",
    "峰值": "峰值",
    "峭度": "峭度",
    "歪度": "歪度",
    "最大值": "最大值",
    "最小值": "最小值",
    "压力": "压力",
    "振动": "振动",
    "温度": "温度",
    "流量": "流量",
    "其它": "其它",
    "撞击": "撞击",
    "直流量": "直流量",
    "有效值": "有效值",
    "平均压力": "平均压力",
    "机械效率": "机械效率",
    "吸气容积效率": "吸气容积效率",
    "排气容积效率": "排气容积效率",
    "单缸指示功率": "单缸指示功率",
    "压缩指数": "压缩指数",
    "膨胀系数": "膨胀系数",
    "实际压力比": "实际压力比",
    "沉降量/偏摆量": "沉降量/偏摆量",
    "峰-峰值": "峰-峰值",
    "活塞-气缸剩余间隙": "活塞-气缸剩余间隙",
    "一倍频幅值": "一倍频幅值",
    "二倍频幅值": "二倍频幅值",
    "间隙电压": "间隙电压",
    "加速度峰值": "加速度峰值",
    "加速度高频": "加速度高频",
    "加速度低频": "加速度低频",
    "加速度波形峭度": "加速度波形峭度",
    "速度有效值": "速度有效值",
    "通频gIE值": "通频gIE值",
    "加速度真峰值": "加速度真峰值",
    "通频有效值": "通频有效值",
    "1倍频有效值": "1倍频有效值",
    "2倍频有效值": "2倍频有效值",
    "3倍频有效值": "3倍频有效值",
    "1/2倍频有效值": "1/2倍频有效值",
    "残振有效值": "残振有效值",
    "无线振动速度有效值": "无线振动速度有效值",
    "无线振动位移峰值": "无线振动位移峰值",
    "无线振动加速度有效峰值": "无线振动加速度有效峰值",
    "振动速度有效值": "振动速度有效值",
    "振动加速度有效峰值": "振动加速度有效峰值",
    "振动加速度低频值": "振动加速度低频值",
    "振动加速度真峰值": "振动加速度真峰值",
    "振动位移峰峰值": "振动位移峰峰值",
    "1倍频相位": "1倍频相位",
    "2倍频相位": "2倍频相位",
    "3倍频相位": "3倍频相位",
    "1/2倍频相位": "1/2倍频相位",
    "寻峰个数:": "寻峰个数:",
    "谐频倍数:": "谐频倍数:",
    "缺陷频率:": "缺陷频率:",
    "叶片频率:": "叶片频率:",
    "显示": "显示",
    "隐藏": "隐藏",
    "事件描述:": "事件描述:",
    "输入事件内容": "输入事件内容",
    "事件查询": "事件查询",
    "图谱显示:": "图谱显示:",
    "分析线数:": "分析线数:",
    "比较类型:": "比较类型:",
    "径向振动": "径向振动",
    "轴向位移": "轴向位移",
    "设备名称:": "设备名称:",
    "事件查询:": "事件查询:",
    "类型选择:": "类型选择:",
    "请选择类型": "请选择类型",
    "请选择缸号": "请选择缸号",
    "请选择图谱": "请选择图谱",
    "请输入数字": "请输入数字",
    "选择分析线数": "选择分析线数",
    "趋势类型:": "趋势类型:",
    "图谱选择:": "图谱选择:",
    "图谱显示": "图谱显示",
    "时间选择:": "时间选择:",
    "模式选择:": "模式选择:",
    "转速时间": "转速时间",
    "波德图": "波德图",
    "相位时间": "相位时间",
    "极坐标图": "极坐标图",
    "查询": "查询",
    "刷新": "刷新",
    "停止": "停止",
    "启停车日志:": "启停车日志:",
    "事件id": "事件id",
    "事件标记描述": "事件标记描述",
    "状态": "状态",
    "转速(r/min)": "转速(r/min)",
    "日志": "日志",
    "开始时间:": "开始时间:",
    "结束时间:": "结束时间:",
    "使用": "使用",
    "不使用": "不使用",
    "选择年月:": "选择年月:",
    "yyyy 年 MM 月": "yyyy 年 MM 月",
    "实时": "实时",
    "历史": "历史",
    "参数区间:": "参数区间:",
    "选择测点:": "选择测点:",
    "全部": "全部",
    "曲轴箱": "曲轴箱",
    "1缸": "1缸",
    "2缸": "2缸",
    "3缸": "3缸",
    "4缸": "4缸",
    "5缸": "5缸",
    "6缸": "6缸",
    "趋势": "趋势",
    "波形": "波形",
    "频谱": "频谱",
    "缸号选择:": "缸号选择:",
    '特征': '特征',
    '壳体振动': '壳体振动',
    '曲轴箱振动': '曲轴箱振动',
    "其它振动": "其它振动",
    '活塞杆沉降/偏摆': '活塞杆沉降/偏摆 ',
    '动态压力': '动态压力',
    "启停车测点": "启停车测点",
    "振动-加速度": "振动-加速度",
    "振动-位移": "振动-位移",
    "振动-速度": "振动-速度",
    "位移": "位移",
    "湿度": "湿度",
    "加速度": "加速度",
    "速度": "速度",
    "撞击次数": "撞击次数",
    "温度测点": "温度测点",
    "压力测点": "压力测点",
    "流量测点": "流量测点",
    "振动测点": "振动测点",
    "轴心轨迹测点树关键字": "轴心轨迹",
    "轴心位置测点树关键字": "轴心位置",
    "频率": "频率",
    "相位": "相位",
    "不同测点": "不同测点",
    "相同测点": "相同测点",
    "前一阶段": "前一阶段",
    "起止时间": "起止时间",
    "起止月": "起止月",
    "前5分钟": "前5分钟",
    "前半小时": "前半小时",
    "前1小时": "前1小时",
    "前1天": "前1天",
    "前1周": "前1周",
    "前1月": "前1月",
    "前1季度": "前1季度",
    "前1年": "前1年",
    "时间选择错误": "时间选择错误",
    "请确保开始时间早于终止时间": "请确保开始时间早于终止时间",
    "确定": "确定",
    '搜索组织结构': '搜索组织结构',
    '筛选设备类型': '筛选设备类型',
    '旋转': '旋转',
    '燃气轮机': '燃气轮机',
    '往复': '往复',
    '机泵': '机泵',
    '风电': '风电',
    '燃气发动机': '燃气发动机',
    '内燃机': '内燃机',
    '无线机泵': '无线机泵',
    '组织机构': '组织机构',
    "旋转机械专用图谱": "旋转机械专用图谱",
    "振动监测": "振动监测",
    "机组概貌图": "机组概貌图",
    "单多值棒图": "单多值棒图",
    "温度分布场": "温度分布场",
    "振动历史比较": "振动历史比较",
    "其它参数趋势图": "其它参数趋势图",
    "综合分析": "综合分析",
    "冲击诊断": "冲击诊断",
    "轴心轨迹-菜单关键字": "轴心轨迹",
    "轴心位置-菜单关键字": "轴心位置",
    "全频谱图-菜单关键字": "全频谱图",
    "启停车图形": "启停车图形",
    "旋转报警查询": "报警查询",
    "参数比较查询": "参数比较查询",
    "运行状态图": "运行状态图",
    "倒谱图-菜单关键字": "倒谱图",
    "往复机械专用图谱": "往复机械专用图谱",
    "单值棒图-菜单关键字": "单值棒图",
    "历史比较图": "历史比较图",
    "综合监测": "综合监测",
    "活塞杆沉降/偏摆监测-菜单关键字": "活塞杆沉降/偏摆监测",
    "示功图": "示功图",
    "多参数分析-菜单关键字": "多参数分析",
    "往复报警查询": "报警查询",
    "机泵报警查询": "报警查询",
    "趋势分析": "趋势分析",
    "分析图谱": "分析图谱",
    "机泵专用图谱": "机泵专用图谱",
    "活塞杆载荷分析": "活塞杆载荷分析",
    "无线机泵专用图谱": "无线机泵专用图谱",
    "波形频谱对比分析": "波形频谱对比分析",
    "边缘计算特征值趋势图": "边缘计算特征值趋势图",
    "报警查询": "报警查询",
    "语言": "语言",
    "中文": "中文",
    "英文": "英文",
    "俄文": "俄文",
    "更改主题": "更改主题",
    "静谧蓝": "静谧蓝",
    "默认": "默认",
    "暗黑": "暗黑",
    "无数据": "无数据",
    "范围内无数据点": "范围内无数据点",
    "数据加载中": "数据加载中...",
    "数据获取失败": "数据获取失败",
    "请选择事件": "请选择事件",
    "缺陷频率无数据": "缺陷频率无数据",
    "请输入标注": "请输入标注",
    "取消": "取消",
    "选择开始时间": "选择开始时间",
    "选择结束时间": "选择结束时间",
    "关注": "关注",
    "取消关注": "取消关注",
    "显示全部点": "显示全部点",
    "仅显示波形点": "仅显示波形点",
    "仅显示长波形点": "仅显示长波形点",
    "X轴真峰值": "X轴真峰值",
    "X轴有效峰值": "X轴有效峰值",
    "X轴有效值": "X轴有效值",
    "X轴峰峰值": "X轴峰峰值",
    "Y轴真峰值": "Y轴真峰值",
    "Y轴有效峰值": "Y轴有效峰值",
    "Y轴有效值": "Y轴有效值",
    "Y轴峰峰值": "Y轴峰峰值",
    "Z轴真峰值": "Z轴真峰值",
    "Z轴有效峰值": "Z轴有效峰值",
    "Z轴有效值": "Z轴有效值",
    "Z轴峰峰值": "Z轴峰峰值",
    "MCU温度": "MCU温度",
    "振动趋势图": "振动趋势图",
    "转速趋势图": "转速趋势图",
    "X轴加速度": "X轴加速度",
    "Y轴加速度": "Y轴加速度",
    "Z轴加速度": "Z轴加速度",
    "无线toC设备专用图谱": "无线toC设备专用图谱",
    "补偿": "补偿",
    "无": "无",
    "从数据库选择": "从数据库选择",
    "第一个样本": "第一个样本",
    "最后一个样本": "最后一个样本",
    "当前样本": "当前样本",
    "创建新数据集": "创建新数据集",
    "未选中补偿点": "未选中补偿点",
    "通频振动": "通频振动",
    "低压转子1X振动": "低压转子1X振动",
    "低压转子2X振动": "低压转子2X振动",
    "低压转子谐波振动": "低压转子谐波振动",
    "高压转子1X振动": "高压转子1X振动",
    "高压转子2X振动": "高压转子2X振动",
    "高压转子谐波振动": "高压转子谐波振动",
    "动力涡轮1X振动": "动力涡轮1X振动",
    "动力涡轮2X振动": "动力涡轮2X振动",
    "动力涡轮谐波振动": "动力涡轮谐波振动",
    "低频残振": "低频残振",
    "高频残振": "高频残振",
    "燃气轮机专用图谱": "燃气轮机专用图谱",
    "未选中补偿数据集": "未选中补偿数据集",
    "获取失败": "获取失败",
    "名称": "名称",
    "请输入名称": "请输入名称",
    "请选择子类型": "请选择子类型",
    "至少选择一个补偿范围": "至少选择一个补偿范围",
    "创建成功": "创建成功",
    "创建失败": "创建失败",
    "序号": "序号",
    "类型": "类型",
    "子类型": "子类型",
    "时间戳": "时间戳",
    "操作": "操作",
    "删除成功": "删除成功",
    "删除失败": "删除失败",
    "设置成功": "设置成功",
    "设置失败": "设置失败",
    "未选中样本": "未选中样本",
    "启动": "启动",
    "停机": "停机",
    "其他": "其他",
    "热": "热",
    "冷": "冷",
    "矢量": "矢量",
    "间隙": "间隙",
    "补偿范围": "补偿范围",
    "保存": "保存",
    "数据导出": "数据导出",
    "包络波形": "包络波形",
    "包络频谱": "包络频谱",
    "包络方式": "包络方式",
    "高通": "高通",
    "带通": "带通",
    "截止频率": "截止频率",
    "上截止频率": "上截止频率",
    "下截止频率": "下截止频率",
    "请输入截止频率":"请输入截止频率",
    "平均值（轴向位移）": "平均值",
    "没有设置报警门限": "没有设置报警门限",
    "断网": "断网",
    "正常": "正常",
    "智能一级": "智能一级",
    "智能二级": "智能二级",
    "智能三级": "智能三级",
    "固定高报": "固定高报",
    "固定高高报": "固定高高报",
    '频谱瀑布图': '频谱瀑布图',
    '峰值趋势': '峰值趋势',
    '分析诊断': '分析诊断',
    '时间': '时间',
    '测点': '测点',
    '趋势特征值': '趋势特征值',
    '测量类型': '测量类型',
    '特征类型': '特征类型',
    '缓变量测点': '缓变量测点',
    '平均值（特征值）': '平均值',
    '峰峰值（特征值）': '峰峰值',
    'gIE值': 'gIE值',
    '真峰值': '真峰值',
    '真峰峰值': '真峰峰值',
    '加速度冲击': '加速度冲击',
    '振动趋势': '振动趋势',
    '包络分析': '包络分析',
    '缓变量趋势': '缓变量趋势',
  }
}



// WEBPACK FOOTER //
// ./src/language/zh.js